import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { setActiveApp } from '@modules/app/AppActions';
import { ProdigyApp, getActiveApp } from '@modules/app/AppReducer';

const mapRouteToProdigyApp = route => {
  if (/^\/appraisal/gi.test(route)) {
    return ProdigyApp.Appraisal;
  }
  if (/^\/apprdemo/gi.test(route)) {
    return ProdigyApp.AppraisalDemo;
  }
  if (/^\/assessment/gi.test(route)) {
    return ProdigyApp.Assessment;
  }
  if (/^\/ci/gi.test(route)) {
    return ProdigyApp.CI;
  }
  if (/^\/equityFinder/gi.test(route)) {
    return ProdigyApp.EquityFinder;
  }
  if (/^\/events/gi.test(route)) {
    return ProdigyApp.Events;
  }
  if (/^\/equityFinder/gi.test(route)) {
    return ProdigyApp.EquityFinder;
  }
  if (/^\/litigation/gi.test(route)) {
    return ProdigyApp.Litigation;
  }
  if (/^\/maintenance/gi.test(route)) {
    return ProdigyApp.Maintenance;
  }
  if (/^\/mra/gi.test(route)) {
    return ProdigyApp.MRA;
  }
  if (/^\/sketch/gi.test(route)) {
    return ProdigyApp.Sketch;
  }
  if (/^\/appraisal-admin/gi.test(route)) {
    return ProdigyApp.AppraisalAdmin;
  }

  return null;
};

function* updateProdigyApp({
  payload: {
    location: { pathname },
  },
}) {
  const nextProdigyApp = yield call(mapRouteToProdigyApp, pathname);
  const currProdigyApp = yield select(getActiveApp);

  if (currProdigyApp !== nextProdigyApp) {
    yield put(setActiveApp(nextProdigyApp));
  }
}

function* routerSagas() {
  yield all([takeLatest('@@router/LOCATION_CHANGE', updateProdigyApp)]);
}

export default routerSagas;
